
import colors from "assets/theme-dark/base/colors";
import boxShadows from "assets/theme-dark/base/boxShadows";
import borders from "assets/theme-dark/base/borders";

const { background,text} = colors;

const paper = {
    styleOverrides: {
        root: {
            backgroundColor: background.default,
            '& .MuiTypography-root':{
                color: text.main,
            },
            '& .MuiPickersCalendarHeader-label':{
                color: text.main,
            },
            '& .MuiDayCalendar-monthContainer button': {
                color: text.main, // 将按钮颜色改为红色
            },


        },

    },
};

export default paper